import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { BusinessActionsActivity } from 'app/model/pipeline/business-actions.activity';
import { ApiIntegrationActivityAdapter } from './api-integration.activity.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BusinessActionsActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            serviceType: '*',
            itemType: '*',
            workspaceId: '*',
            itemId: '*',
            apiRequest: '*',
            apiParameters: '*'
        }
    }
})
export class BusinessActionsActivityAdapter extends ApiIntegrationActivityAdapter {
    public override model(): IModel {
        return Metamodel.modelFor(BusinessActionsActivity);
    }

    protected override _createActivity(name: string, description?: string): BusinessActionsActivity {
        return BusinessActionsActivity.MODEL.create<BusinessActionsActivity>(name, description);
    }
}
